__turbopack_context__.v({
  "image": "ProfileImage-module-scss-module__zgtoVq__image",
  "imageWrapper": "ProfileImage-module-scss-module__zgtoVq__imageWrapper",
  "input": "ProfileImage-module-scss-module__zgtoVq__input",
  "inputWrapper": "ProfileImage-module-scss-module__zgtoVq__inputWrapper",
  "label": "ProfileImage-module-scss-module__zgtoVq__label",
  "wrapper": "ProfileImage-module-scss-module__zgtoVq__wrapper",
});
